import { EnglishArabicDTO } from "bbsf-controls"
export class EmailHeaderAndFooterTemplate
{
      ID:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      Header :EnglishArabicDTO=new EnglishArabicDTO();
      Footer :EnglishArabicDTO=new EnglishArabicDTO();
      HeadSection :EnglishArabicDTO=new EnglishArabicDTO();
      HeadTagAttributes :EnglishArabicDTO=new EnglishArabicDTO();
      IDEncrypted :string
}
     